import { useSettingsContext } from '@/hooks/useSettingsContext';
import { X } from 'lucide-react';
import { useState } from 'react';

export const InfoBanner = () => {
  const { settings, loading } = useSettingsContext();
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show during loading (prevents flash of cached content), if not enabled, no text, or dismissed
  if (loading || !settings?.bannerEnabled || !settings?.bannerText || isDismissed) {
    return null;
  }

  return (
    <div 
      className="w-full py-2 px-4 text-center text-sm font-medium relative"
      style={{ 
        backgroundColor: settings.bannerBgColor || '#1a365d',
        color: settings.bannerTextColor || '#ffffff'
      }}
    >
      <div className="container mx-auto flex items-center justify-center gap-2">
        <span>{settings.bannerText}</span>
        {settings.bannerLink && settings.bannerLinkText && (
          <a 
            href={settings.bannerLink}
            className="underline hover:opacity-80 transition-opacity font-semibold"
            style={{ color: settings.bannerTextColor || '#ffffff' }}
          >
            {settings.bannerLinkText}
          </a>
        )}
      </div>
      <button
        onClick={() => setIsDismissed(true)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:opacity-70 transition-opacity"
        aria-label="Fermer le bandeau"
        style={{ color: settings.bannerTextColor || '#ffffff' }}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};